import { MSG, wa } from "../../data/site";
import { WhatsAppIcon } from "./Icons";
import { Reveal } from "./Reveal";

export const EndoDelivery = () => (
    <section
        id="endo-delivery"
        data-testid="endo-delivery-section"
        className="relative overflow-hidden bg-[#0B132B] py-24 md:py-32"
    >
        <div
            className="pointer-events-none absolute -left-32 top-0 h-96 w-96 rounded-full bg-sky-500/10 blur-3xl"
            aria-hidden="true"
        />
        <div
            className="pointer-events-none absolute -right-24 bottom-0 h-80 w-80 rounded-full bg-[#1A6AFF]/15 blur-3xl"
            aria-hidden="true"
        />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-3xl text-center">
                <Reveal>
                    <span
                        className="inline-flex items-center gap-2 rounded-full border border-sky-400/25 bg-sky-400/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-sky-300"
                        data-testid="endo-delivery-badge"
                    >
                        Para dentistas e clínicas
                    </span>
                </Reveal>
                <Reveal delay={0.08}>
                    <h2 className="mt-6 text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
                        Endodontia especializada para profissionais e consultórios parceiros
                    </h2>
                </Reveal>
                <Reveal delay={0.16}>
                    <p className="mt-5 text-base leading-relaxed text-slate-300 md:text-lg">
                        Conte com suporte especializado em endodontia para complementar o atendimento
                        oferecido aos seus pacientes.
                    </p>
                    <p className="mt-3 text-sm leading-relaxed text-slate-400">
                        Entre em contato para conhecer o serviço de Endo Delivery e verificar as
                        possibilidades de parceria.
                    </p>
                </Reveal>
                <Reveal delay={0.24}>
                    <a
                        href={wa(MSG.endoDelivery)}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="endo-delivery-whatsapp-button"
                        className="mt-9 inline-flex items-center gap-2.5 rounded-full bg-sky-400 px-7 py-4 text-sm font-semibold text-[#0B132B] shadow-xl shadow-sky-400/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-sky-300"
                    >
                        <WhatsAppIcon className="h-5 w-5" />
                        Sou dentista e quero conhecer o Endo Delivery
                    </a>
                </Reveal>
            </div>
        </div>
    </section>
);
